export default __webpack_public_path__ + "static/media/job_offer7_xl.53865fc3.jpg";